import { CompSwitchCore } from '../core/forms/switch/comp'

export const CompSwitch = CompSwitchCore
